import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

const SECTIONS = [
  'controller',
  'dataCollected',
  'purpose',
  'legalBasis',
  'subprocessors',
  'transfers',
  'retention',
  'rights',
  'cookies',
  'contact',
] as const;

export default function Privacidade() {
  const { t, i18n } = useTranslation();
  const isPortuguese = i18n.language.startsWith('pt');

  return (
    <div className="min-h-screen bg-background py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <Button variant="ghost" size="sm" asChild className="mb-6">
          <Link to="/"><ArrowLeft className="h-4 w-4 mr-1" /> {t('common.back')}</Link>
        </Button>

        <h1 className="text-3xl font-bold mb-2">{t('landing.privacy.title')}</h1>

        {isPortuguese ? (
          <>
            <p className="text-sm text-muted-foreground mb-6">{t('landing.privacy.lastUpdated')}</p>
            <p className="mb-8">{t('landing.privacy.intro')}</p>

            {SECTIONS.map((key) => (
              <section key={key} className="mb-6">
                <h2 className="text-xl font-semibold mb-2">{t(`landing.privacy.sections.${key}.title`)}</h2>
                <p className="text-muted-foreground whitespace-pre-line">
                  {t(`landing.privacy.sections.${key}.body`)}
                </p>
              </section>
            ))}
          </>
        ) : (
          <>
            <p className="mb-6">{t('landing.privacy.placeholder')}</p>
            <Button asChild variant="outline">
              <Link to="/privacidade" onClick={() => i18n.changeLanguage('pt')}>
                {t('landing.privacy.link')}
              </Link>
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
